import React, { useState,useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const Editroom = () => {
    const navigate = useNavigate();
    const { roomId } = useParams();
    const [roomDetails, setRoomDetails] = useState({
        roomNumber: '',
        roomRent: 0, 
        locationurl: '',
        photos: ['', '', ''],
        phonenumber: '',
        whatsappenabled: false,
        AC : false,
        Wifi: false,
         Electricity: false,
         RO : false
      });
      
      useEffect(() => {
        const fetchRoomDetails = async () => {
          try {
            const response = await fetch(`https://pgdost.onrender.com/api/rooms/${roomId}`);
            if (response.ok) {
              const data = await response.json();
              setRoomDetails({
                roomNumber: data.pgName, // Update to match API response
                roomRent: data.roomRent,
                locationurl: data.locationurl,
                photos: data.photos,
                phonenumber: data.phno,
                whatsappenabled: data.whatsappenabled,
                AC: data.AC,
                Wifi : data.Wifi,
                Electricity : data.Electricity,
                RO : data.RO
              });
            } else {
              console.error('Error fetching room details:', response.statusText);
            }
          } catch (error) {
            console.error('Error fetching room details:', error);
          }
        };
      
        fetchRoomDetails();
      }, [roomId]);
    console.log("Room Details" ,roomDetails)
    useEffect(() => {
      if (localStorage.getItem('email') == null && localStorage.getItem('password') == null) {
        navigate('/login');
      }
    }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Use the `checked` property for checkboxes
    setRoomDetails((prevDetails) => ({
      ...prevDetails,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleImageChange = (index, e) => {
    const { files } = e.target;
    if (files.length > 0) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const base64Image = event.target.result;
        const newPhotos = [...roomDetails.photos];
        newPhotos[index] = base64Image;

        setRoomDetails((prevDetails) => ({
          ...prevDetails,
          photos: newPhotos,
        }));
      };

      reader.readAsDataURL(files[0]);
    }
  };

  const handleupdateRoom = async () => {
    // Validate required fields
    if (!roomDetails.roomNumber || !roomDetails.roomRent || !roomDetails.phonenumber || !roomDetails.photos[0] || !roomDetails.locationurl ) {
      toast.error('Please Fill All The Required Details');
      return;
    }
  
    try {
      const response = await fetch(`https://pgdost.onrender.com/api/rooms/${roomId}`, {
        method: 'PUT', // Change the method to PUT
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomemail: localStorage.getItem('email'),
          pgName: roomDetails.roomNumber,
          roomRent: roomDetails.roomRent,
          locationurl: roomDetails.locationurl,
          phno: roomDetails.phonenumber,
          whatsappenabled: roomDetails.whatsappenabled,
          AC : roomDetails.AC,
          Electricity: roomDetails.Electricity,
          Wifi: roomDetails.Wifi,
          RO : roomDetails.RO,
          photos: roomDetails.photos,
        }),
      });
  
      if (response.ok) {
        // Room details updated successfully
        console.log('Room details updated successfully');
        toast.success("Room details updated successfully");
        setTimeout(() => {
            navigate('/home');
        }, 1000);
       
        // You can redirect the user or perform any other actions here
      } else {
        // Error in updating room details
        console.error('Error updating room details');
      }
    } catch (error) {
      console.error('Error updating room details:', error);
    }
  };
  
  return (
    <div className="flex justify-center">
      {/* Form Input Section */}
      <div className="w-1/2 p-4">
        <h2 className="text-2xl font-semibold mb-4">Add Room Details</h2>
       
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">PG Name<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="roomNumber"
              value={roomDetails.roomNumber}
              onChange={handleChange}
              className="mt-1 p-2 border rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Room Rent<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="roomRent"
              value={roomDetails.roomRent}
              onChange={handleChange}
              className="mt-1 p-2 border rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Phone Number<span className="text-red-500">*</span></label>
            <input
              type="Number"
              name="phonenumber"
              value={roomDetails.phonenumber}
              onChange={handleChange}
              className="mt-1 p-2 border rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                name="whatsappenabled"
                checked={roomDetails.whatsappenabled}
                onChange={handleChange}
                className="mr-2"
              />
              Enable WhatsApp
            </label>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Location<span className="text-red-500">*</span></label>
            <input
              type="text"
              name="locationurl"
              value={roomDetails.locationurl}
              onChange={handleChange}
              className="mt-1 p-2 border rounded w-full"
              required
            />
          </div>
          {/* Image Input Fields */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Main Image<span className="text-red-500">*</span></label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(0, e)}
              className="mt-1 p-2 border rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Image 2</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(1, e)}
              className="mt-1 p-2 border rounded w-full"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Image 3</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(2, e)}
              className="mt-1 p-2 border rounded w-full"
            />
          </div>
          <label className='block text-sm font-medium text-gray-700 mb-4'> Room functionalities : 
        {/* Checkbox for WiFi */}
        
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="AC"
              checked={roomDetails.AC}
              onChange={handleChange}
              className="mr-2"
            />
            AC
          </label>
        </div>
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="Wifi"
              checked={roomDetails.Wifi}
              onChange={handleChange}
              className="mr-2"
            />
            WiFi
          </label>
        </div>

        {/* Checkbox for Electricity Backup */}
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="Electricity"
              checked={roomDetails.Electricity}
              onChange={handleChange}
              className="mr-2"
            />
            Electricity Backup
          </label>
        </div>

        {/* Checkbox for RO Purifier */}
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="RO"
              checked={roomDetails.RO}
              onChange={handleChange}
              className="mr-2"
            />
            RO Purifier
          </label>
        </div>
        </label>



          <button
          onClick={handleupdateRoom}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Update Room Details
        </button>
          
       
      </div>

      {/* Preview Section */}
      <div className="w-1/2 p-4">
        <h2 className="text-2xl font-semibold mb-4">Your Post  Preview</h2>
        <div className="max-w-md bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden dark:bg-gray-800 dark:border-gray-700 mx-auto">
          <img
            className="w-full h-40 object-cover rounded-t-lg"
            src={roomDetails.photos[0] || 'placeholder-image.jpg'}
            alt={`Room image`}
          />
          <div className="px-6 py-4">
            <h5 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">
              {roomDetails.roomNumber || 'PG Name'}
            </h5>
            <div className="flex items-center mt-2.5 mb-4 space-x-2">
              {/* Add buttons for preview section if needed */}
            </div>
            <div className="flex items-center justify-between">
              <span className="text-3xl font-bold text-gray-900 dark:text-white">
                ₹{roomDetails.roomRent || 'Room Rent'}/month
              </span>
              <a href={roomDetails.locationUrl} target="_blank" rel="noopener noreferrer" className="btn-blue">
                See More
              </a>
            </div>

          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};


